<template>
  <div ref="LoginForm" >
    <p class="text-right margin-a-z" v-if="isLoggedIn">
      <span class="margin-r-xs">
        {{ $t('customerForm.not') }}
        {{ firstName }}?</span>
      <a href="javascript:;" v-on:click="logoutSubmit">{{ $t('customerForm.signOut') }}</a>
    </p>
    <p class="text-right margin-a-z" v-else>
      {{ $t('customerForm.alreadyHave') }}
      <a v-on:click="showHideForm" href="javascript:;">{{ $t('customerForm.signIn2') }}</a>
    </p>

    <div v-bind:class="['login-form showhide-fadeslide', (isHidden? 'hide' : '')]">
      <div :class="['padding-a-m', isSafari]">
        <form action="#" v-on:submit.prevent="loginSubmit" v-bind:class="['showhide-fadeslide', (hideLogin ? 'hide' : '')]" data-vv-scope="login-form">
          <div :class="isSafari">
            <div v-if="flashData.type == 'login'" v-bind:class="['alert-wrap showhide-fadeslide', (flashData.message === ''? 'hide' : '')]">
              <div v-bind:class="['alert margin-b-s', (loginResponse), isSafari]">
                {{ flashData.message }}
              </div>
            </div>
            <div class="row">
              <div class="medium-6 column padding-r-s small-padding-h-z">
                <div :class="['field-group', {'field-error': error.email}]">
                  <label class="field-label">{{ $t('customerForm.emailUsername') }}</label>
                  <input type="text" name="email" placeholder="johndoe@gmail.com"
                    :class="['field-text', (isLoading? 'disabled' : '')]"
                    :disabled="isLoading" v-model="email" ref="email" />
                  <span v-show="error.email" class="field-error-message">{{ error.email }}</span>
                </div>
              </div>
              <div class="medium-6 columns padding-l-s small-padding-h-z">
                <div :class="['field-group', {'field-error': error.password}]">
                  <label class="field-label">{{ $t('common.password') }}</label>
                  <input type="password" name="password" placeholder="Password"
                    :class="['field-text', (isLoading? 'disabled' : '')]"
                    :disabled="isLoading" v-model="password"  />
                  <span v-show="error.password" class="field-error-message">{{ error.password }}</span>
                </div>
              </div>
            </div>
            <div class="row">
            <div class="medium-6 columns">
              <a href="javascript:;" v-on:click="showHideForgotPassword('show')">{{ $t('customerForm.forgotPass') }}</a>
            </div>
            <div class="medium-6 columns margin- t-m">
              <button v-bind:class="['op-btn btn-success btn-lg f-right', (isLoading? 'loading' : '')]">
                <span class="original-label">{{ $t('customerForm.signIn2') }}</span>
                <div class="loaderx">
                  <icon name="refresh" spin class="magin-r-xs"></icon>
                  {{ $t('common.loading') }}
                </div>
              </button>
            </div>
          </div>
          </div>
        </form>
        <div class="row">
          <div class="medium-12 columns">
            <forgot-password-form :showForm="[hideLogin ? '' : 'hide']" :flash="flash" @hideForgotPassword="hideForgotPassword" ref="forgotPasswordForm" ></forgot-password-form>
          </div>
        </div>
      </div>

    </div>

    <div class="corporate-box row" v-show="isCorporate">
      <div class="medium-1 column"><img :src="corporateData.logo" ></div>
      <div class="medium-11 column">
        <span class="label">{{ $t('customerForm.corporateAccnt') }}</span>
        <span class="name">{{ corporateData.name }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import uuidv4 from 'uuid/v4'
import VeeValidate from 'vee-validate'
import ForgotPasswordForm from './ForgotPasswordForm.vue'
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'

Vue.use(VeeValidate)

export default {
  name: 'login-form',
  props: [ 'user', 'flash', 'show' ],
  data () {
    return {
      isHidden: !this.show,
      hideLogin: false,
      email: null,
      password: null,
      isLoading: false,
      loginResponse: '',
      isSafari: (navigator.userAgent.indexOf('Safari') !== -1 &&
        navigator.userAgent.indexOf('Chrome') === -1) ||
        navigator.userAgent.indexOf('Edge') > -1 ? 'safari' : '',
      error: {
        email: '',
        password: ''
      }
    }
  },
  components: {
    'forgot-password-form': ForgotPasswordForm
  },
  computed: {
    userStore () { return this.$store.state.user },
    isLoggedIn: function () {
      let self = this
      self.errors.items = []

      // if (typeof self.$store.state.user.emailSubscribed === 'undefined' && self.$store.state.user.token) {
      //   self.$sdk.get(self, '/me', { token: self.$store.state.user.token }, res => {
      //     if (!res.error) {
      //       self.$store.commit('user/setEmailSubscribed', res.emailSubscribed === 1)
      //     }
      //   })
      // }

      return (self.userStore && self.userStore.firstName) || self.isCorporate
    },
    flashData: function () { return this.flash },
    firstName () { return this.$store.state.user.firstName },
    isCorporate () { return this.$store.state.user.isCorporate },
    corporateData () { return this.$store.state.user.corporate }
  },
  methods: {
    showHideForm: function () {
      let self = this
      if (self.isHidden) self.$emit('open')

      self.isHidden = !self.isHidden
      if (!self.isHidden) {
        self.$nextTick(function () {
          if (self.$refs.email) {
            self.$refs.email.focus()
          }
        })
        self.$scrollTo(self.$refs.LoginForm)
      }
    },
    loginSubmit: function () {
      let self = this
      if (this.isLoading) return
      this.errors.items = []
      this.error = {
        email: '',
        password: ''
      }
      let hasError = false
      if (!self.email) {
        hasError = true
        self.error.email = self.$t('common.fieldRequired', {field: 'email'})
      }
      // let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // if (self.email && !pattern.test(self.email)) {
      //   hasError = true
      //   self.error.email = self.$t('common.invalidEmail')
      // }
      if (!self.password) {
        hasError = true
        self.error.password = self.$t('common.fieldRequired', {field: 'password'})
      }
      if (hasError) return

      this.isLoading = true
      self.$store.commit('user/setIsCorporate', false)
      if (self.email.indexOf('@') > -1) {
        self.$root.$emit('loginSubmit', {
          email: self.email,
          password: self.password
        })
      } else {
        self.loginCorporate()
      }
    },
    logoutSubmit: function () {
      this.$store.commit('user/setIsCorporate', false)
      this.$root.$emit('logout')
    },
    showHideForgotPassword: function (showHide) {
      if (showHide === 'show') {
        this.hideLogin = true
        let forgotPasswordForm = this.$refs.forgotPasswordForm
        forgotPasswordForm.focusForm()
      } else {
        this.hideLogin = false
      }
      setTimeout(function () { window.scrollTo(0, 0) }, 100)
    },
    hideForgotPassword: function () {
      this.hideLogin = false
      this.$refs.email.focus();
    },
    forceHideForm: function () {
      this.isHidden = true
    },
    forceShowForm: function () {
      this.isHidden = false
      this.$refs.email.focus();
      this.$scrollTo(this.$refs.LoginForm);
    },
    loginCorporate () {
      let self = this
      let token = 'CORP-' + uuidv4()

      self.$sdk.post(self, '/auth/login/corporate', {
        username: self.email,
        password: self.password,
        token: token
      }, res => {
        if (!res.error) {
          self.$root.$emit('setSession', token)
          self.$store.commit('user/setToken', token)
          self.$store.commit('user/setUserInfo', {
            ID: res.id,
            email: res.contactEmail,
            firstName: res.name,
            lastName: '',
            phone: {
              number: res.contactPhone,
              code: res.countryCode || ''
            }
          })

          self.$store.commit('user/setIsCorporate', true)
          self.$store.commit('user/setCorporateData', {
            name: res.name,
            logo: res.logoUrl
          })
          self.isLoading = false
          self.loginResponse = 'success'
          self.showHideForm()

          self.flash.type = ''
          self.flash.message = ''

          if (res.discountCode) {
            self.$root.$emit('redeemCode', {code: res.discountCode})
          }

          self.pickupTypeUpdate({
            countryCode: res.countryCode || '',
            phone: res.contactPhone
          })
        } else {
          self.flash.type = 'login'
          self.flash.message = res.error.message
          self.loginFail(res.error.message)
        }
      })
    },
    loginFail (msg) {
      let self = this
      self.isLoading = false
      self.loginResponse = 'error'
      self.$store.commit('user/setIsCorporate', false)
    },
    pickupTypeUpdate (userInfo) {
      let self = this

      let userPhone = '+' + userInfo.countryCode + userInfo.phone
      let notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      ApiPickupType.update(self, {isUS: notInternational}, function (data) {
        if (data.action === 'mobileCCUpdate') {
          let rsvp = self.$store.state.reservation
          if (rsvp.leg1.isAirportPickup) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg1.pickupType,
              fee: rsvp.leg1.pickupFee
            })
          }
          if (rsvp.isRoundtrip && rsvp.leg2.pickupHasAirline) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg2.pickupType,
              fee: rsvp.leg2.pickupFee
            })
          }
        }
      })
    }
  },
  mounted: function () {
    var self = this;
    this.$root.$on('loginSuccess', function (userInfo) {
      self.isLoading = false
      self.loginResponse = 'success'
      self.showHideForm();

      if (window.opoliCNS) {
        window.opoliCNS('updateToken', {
          email: userInfo.email,
          phone: `${userInfo.countryCode}${userInfo.phone}`
        })
      }

      self.pickupTypeUpdate(userInfo)
    })
    this.$root.$on('loginFailure', function (message) {
      self.loginFail(message)
    })
  },
  ready: function () {
    this._isLoggedIn
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Customer/LoginForm.scss";
.safari{
  input[type=text]{
    webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
}

.corporate-box{
  border: 1px solid #ccc;
  background: #fafafa;
  border-radius: 2px;
  margin-top: 10px;
  padding: 5px 10px;

  img { width: 50px; }

  .medium-11{ padding-left: 15px; }
  .label{
    display: block;
    font-size: 12px;
    color: #999;
    margin-top: 7px;
    line-height: 1;
  }
  .name{
    display: block;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// LoginForm.vue?b0145696